import Modal from './Modal';
import ButtonRow from './ButtonRow';
import ActionButton from './ActionButton';
import React, {useCallback} from 'react';
import {GridCol, HtmlGridForm, GridRow, GridSection} from './grid-form';
import icons from '../../markons/markons';
import css from './GroupBookingDialog.less';
import _ from 'lodash';
import AioSelect from './aio-inputs/AioSelect'
import type {SegmentBagsValue} from '../models/Segment'
import {rangeInclusive, setKey} from '../util/collections'



interface SegmentBagsDialogProps {
    close: () => void
    value: SegmentBagsValue
    onChange: (value: SegmentBagsValue) => void
}

const BAG_OPTIONS = rangeInclusive(0,100)

export function SegmentBagsDialog({close, value: bags, onChange}: SegmentBagsDialogProps) {
    const inputSelect = useCallback((name) => ({
        value: _.get(bags, name, ''),
        onChange: (ev: React.ChangeEvent<HTMLSelectElement>) => {
            onChange(setKey(bags, name, ev.target.value));
        },
    }), [bags, onChange]);

    const clearForm = useCallback(() => {
        onChange(Object.create(null));
        close();
    }, [close, onChange])

    return <Modal dialogClass={css.dialog}>
        <div className={css.titleBar}>Baggage</div>
        <HtmlGridForm className={css.content}>
            <GridSection>
                <GridRow>
                    <GridCol>
                        <AioSelect icon={icons.faSuitcaseRolling} label="Small Bags" {...inputSelect('small')} options={BAG_OPTIONS} placeholder="— Select Quantity —"/>
                    </GridCol>
                </GridRow>
                <GridRow>
                    <GridCol>
                        <AioSelect icon={icons.faSuitcaseRolling} label="Medium Bags" {...inputSelect('medium')} options={BAG_OPTIONS} placeholder="— Select Quantity —"/>
                    </GridCol>
                </GridRow>
                <GridRow>
                    <GridCol>
                        <AioSelect icon={icons.faSuitcaseRolling} label="Large Bags" {...inputSelect('large')} options={BAG_OPTIONS} placeholder="— Select Quantity —"/>
                    </GridCol>
                </GridRow>
            </GridSection>


            <ButtonRow>
                <ButtonRow.Left>
                    <ActionButton className="btn-save" onClick={close}>Save & Close</ActionButton>
                </ButtonRow.Left>

                <ButtonRow.Right>
                    <ActionButton className="btn-delete" onClick={clearForm}>Clear</ActionButton>
                </ButtonRow.Right>
            </ButtonRow>
        </HtmlGridForm>
    </Modal>
}
